<sl-title title="Account Setup"></sl-title>
<mat-tab-group class="mat-tab-all-height">
	<mat-tab label="Account Structure">
		<mat-card class="linq-card-legacy">
			<sl-table [config]="accountStructureTableConfig" [data]="accountStructureData"></sl-table>
		</mat-card>
		<mat-card class="linq-card-legacy pt-30">
			<sl-form [model]="accountMappingModel" [fields]="accountFields" [form]="accountForm" [options]="accountOptions">
			</sl-form>
		</mat-card>
	</mat-tab>
	<mat-tab label="Account Offset">
		<mat-card class="linq-card-legacy">
			<div class="table-header mat-elevation-z8">
				<sl-title-buttons [buttons]="titleButtons" class="pull-right p-30"></sl-title-buttons>
			</div>
			<sl-table #table [config]="tableConfig" [data]="data" (fieldChanged)="onFieldChanged($event)"></sl-table>
		</mat-card>
	</mat-tab>
</mat-tab-group>